import { Component, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { BundleType } from 'library-explorer';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { QuickSearchInputComponent } from '../quick-search-input/quick-search-input.component';
import { VirtualKeyboardService } from '@app/services/virtual-keyboard.service';

@Component({
    selector: 'app-search-dialog',
    templateUrl: './search-dialog.component.html',
    styleUrls: ['./search-dialog.component.scss'],
    standalone: false
})
export class SearchDialogComponent implements OnInit, OnDestroy {
  @ViewChild(QuickSearchInputComponent) public quickSearchInput: QuickSearchInputComponent;

  @HostBinding('style.height.px') dialogMobileHeight: number;

  private unsubscribe: Subject<void> = new Subject();

  private desktopMediaQuery = window.matchMedia('(min-width: 992px)');
  private readonly DIALOG_HEIGHT_OFFSET = 20;

  constructor(
    private readonly router: Router,
    private readonly virtualKeyboardService: VirtualKeyboardService,
    private readonly dialogRef: MatDialogRef<SearchDialogComponent>) { }

  ngOnInit(): void {
    this.addRouteSubscriptions();
    this.followVisibleViewport();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private followVisibleViewport(): void {
    if (this.desktopMediaQuery.matches) {
      return;
    }

    this.virtualKeyboardService.observe()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(({ height }) => this.dialogMobileHeight = height - this.DIALOG_HEIGHT_OFFSET);
  }

  public close(): void {
    this.dialogRef.close();
  }

  public navigateToSearch(bundle: BundleType = null): void {
    const searchValue = this.quickSearchInput?.searchControl?.value?.trim() || null;

    this.router.navigate(['/search'], {
      queryParams: {
        search: searchValue, bundle
      }
    });
  }

  private addRouteSubscriptions(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.unsubscribe),
      )
      .subscribe(() => {
        this.dialogRef.close();
      });
  }

}
